import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./theme-variables.css";
import "./index.css";
import App, { KioskSignInScreen } from "./App";

const isKioskRoute = window.location.pathname.replace(/\/+$/, "").toLowerCase() === "/kiosk";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    {isKioskRoute ? <KioskSignInScreen /> : <App />}
  </StrictMode>,
);
